import { get } from 'lodash';

export const mapColToCard = ({
  color,
  config,
  cta,
  icon,
  introduction,
  link,
  mediaRatio,
  mediaUrl,
  smallTitle,
  subTitle,
  text,
  theme,
  title,
}) => {
  return {
    closeLabel: get(config, 'common.close'),
    seeMoreLabel: get(config, 'common.seeMore'),
    seeLessLabel: get(config, 'common.loadLess'),
    color: color,
    ctaLabel: cta,
    heading: {
      iconName: icon,
      title: title,
      small: smallTitle,
      subtitle: subTitle,
    },
    introduction: {
      text: introduction,
    },
    link: { url: link },
    media: {
      alt: '',
      ratioKey: mediaRatio,
      url: mediaUrl,
    },
    text: {
      text: text,
    },
    theme,
  };
};
